










import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class DadosLogradouroComponente extends Vue {
    get logradourocomponente () {
        return this.$store.state.cotacao.logradourocomponente;
    }

    set logradourocomponente ( value ) {
        this.$store.commit("SET_BAIRROCOMPONENTE", value);
    }

    get errorLogradouroComponente () {
        return this.$store.state.errors.logradourocomponente;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }
}
